var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapping = function SvgMapping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mapping_svg2__a",
    x1: 62.43,
    x2: 148.45,
    y1: 190.72,
    y2: 46.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#mapping_svg2__a",
    id: "mapping_svg2__b",
    x1: 34.65,
    x2: 120.67,
    y1: 174.11,
    y2: 30.27
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M133.39 132.14c21.28-33.4 18.61-29.23 19.22-30.1 7.75-10.93 11.84-23.79 11.84-37.2C164.45 29.29 135.6 0 100 0S35.55 29.23 35.55 64.84c0 13.4 4.18 26.6 12.18 37.67l18.88 29.62c-20.19 3.1-54.5 12.35-54.5 32.7 0 7.42 4.84 17.99 27.91 26.23 16.11 5.75 37.41 8.92 59.98 8.92 42.2 0 87.89-11.9 87.89-35.16 0-20.36-34.27-29.59-54.5-32.7ZM57.52 96.07c-.06-.1-.13-.2-.2-.3a52.57 52.57 0 0 1-10.05-30.93c0-29.3 23.6-53.12 52.73-53.12s52.73 23.83 52.73 53.12c0 10.93-3.33 21.42-9.63 30.34-.56.74 2.38-3.83-43.11 67.55L57.51 96.07ZM100 188.28c-46.09 0-76.17-13.55-76.17-23.44 0-6.65 15.46-17.58 49.71-21.84l21.52 33.77c1.08 1.69 2.94 2.71 4.94 2.71s3.87-1.02 4.94-2.71L126.46 143c34.25 4.26 49.71 15.19 49.71 21.84 0 9.81-29.81 23.44-76.17 23.44",
    style: {
      fill: "url(#mapping_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 64.84c0-16.15-13.14-29.3-29.3-29.3s-29.3 13.14-29.3 29.3 13.14 29.3 29.3 29.3 29.3-13.14 29.3-29.3m-46.88 0c0-9.69 7.89-17.58 17.58-17.58s17.58 7.89 17.58 17.58-7.89 17.58-17.58 17.58-17.58-7.89-17.58-17.58",
    style: {
      strokeWidth: 0,
      fill: "url(#mapping_svg2__b)"
    }
  }));
};
export default SvgMapping;